var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityFluidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77136 29.978C2.61559 22.6516 6.50039 13.8011 13.8867 8.5266C21.2729 3.25214 29.3637 3.55106 34.5194 10.8775C39.6752 18.2039 45.7353 28.4951 38.349 33.7696C30.9627 39.044 12.9271 37.3044 7.77136 29.978Z",
    fill: "#DCEDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.024 12.2025C30.9074 12.0736 30.7429 12 30.5686 12H17.0686C16.8956 12 16.7299 12.0736 16.6133 12.2025C16.498 12.3301 16.4403 12.502 16.4575 12.675L18.2984 31.0841C18.3303 31.3983 18.5941 31.6364 18.9095 31.6364H28.7277C29.0431 31.6364 29.307 31.3983 29.3377 31.0841L31.1786 12.675C31.197 12.502 31.1405 12.3301 31.024 12.2025ZM29.89 13.2273L29.3905 18.2321C27.8306 18.7365 25.8007 18.9697 24.2077 17.6626C22.2109 16.0242 19.7637 16.3065 18.1045 16.7999L17.7473 13.2273H29.89Z",
    fill: "#103A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityFluidIcon);
export default __webpack_public_path__ + "static/media/activity-fluid-icon.e6c3d08edd1b75ab52c16b9d3e40cbb4.svg";
export { ForwardRef as ReactComponent };